/**
 * @file
 * A generic wrapper component around all the individual widgets.
 */

import * as React from 'react';

// Components
import InfoCard from '../InfoCard/InfoCard';

// Types
import { IDashboardMeta } from '../../types';

interface IProps {
  meta: IDashboardMeta;
  showMeta?: boolean;
  children: React.ReactNode;
}
export class BassComponent extends React.PureComponent<IProps> {
  public static defaultProps = {
    showMeta: true,
  };

  public render() {
    /**
     * @Bass-Blocks-Integration
     * Hard coding env variables to 'local' for now.
     * Checking for `process.env` breaks browser js. The global process object only exists in server side Node environments.
     */
    // const { NODE_ENV } = process.env;
    const NODE_ENV = 'local';
    const { meta, children } = this.props;

    return (
      <React.Fragment>
        {NODE_ENV === 'development' && this.props.showMeta ? (
          <div className="bass-component" data-testid="bass-component">
            <InfoCard metadata={meta} />
            {children}
          </div>
        ) : (
          <React.Fragment>{children}</React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default BassComponent;
